// @mui material components
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

const ConfiguratorRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "openConfigurator",
})<{ openConfigurator?: boolean }>(({ theme, openConfigurator }) => {
  const { palette, transitions } = theme;

  const configuratorWidth = 360;
  const pxToRem = (value: number) => `${value / 16}rem`;

  return {
    position: "fixed",
    top: 0,
    right: openConfigurator ? 0 : -configuratorWidth,
    width: configuratorWidth,
    height: "100vh",
    backgroundColor: palette.background.paper,
    borderLeft: `1px solid ${palette.divider}`,
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
    zIndex: 1301,
    overflowY: "auto",
    overflowX: "hidden",
    padding: `0 ${pxToRem(10)}`,
    transition: transitions.create("right", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),
  };
});

export default ConfiguratorRoot;
